import type { TourStep } from "@/components/GuidedTour";

export const homeTourSteps: TourStep[] = [
  {
    target: "",
    title: "Welcome to Fusion Media",
    titleAr: "مرحباً بك في فيوجن ميديا",
    description: "We'll walk you through the platform in under a minute — everything you need to launch your first DOOH campaign.",
    descriptionAr: "سنأخذك في جولة سريعة عبر المنصة في أقل من دقيقة — كل ما تحتاجه لإطلاق أول حملة إعلانية رقمية خارجية.",
  },
  {
    target: "top-nav",
    title: "Your Command Bar",
    titleAr: "شريط التحكم",
    description: "The top bar is your home base — jump to any section, switch theme or language, and access your account from one place.",
    descriptionAr: "الشريط العلوي هو مركز التحكم — انتقل إلى أي قسم، بدّل المظهر أو اللغة، وادخل إلى حسابك من مكان واحد.",
  },
  {
    target: "nav-primary",
    title: "Main Sections",
    titleAr: "الأقسام الرئيسية",
    description: "Home, Create Campaign, AI Planner, Influencers, Events, and Network — the core of the platform sits right here.",
    descriptionAr: "الرئيسية، إنشاء حملة، مخطط الذكاء الاصطناعي، المؤثرون، الفعاليات، والشبكة — جوهر المنصة هنا.",
  },
  {
    target: "nav-more",
    title: "More Pages",
    titleAr: "صفحات إضافية",
    description: "About, Contact, Help, and policies live here. Extra links also collapse into this menu on smaller screens.",
    descriptionAr: "من نحن، تواصل، المساعدة، والسياسات هنا. تنطوي روابط إضافية داخل هذه القائمة على الشاشات الأصغر.",
  },
  {
    target: "nav-cta",
    title: "Get Started",
    titleAr: "ابدأ الآن",
    description: "Sign in to create campaigns, save drafts, and track performance. Already in? This jumps straight to your dashboard.",
    descriptionAr: "سجّل الدخول لإنشاء الحملات وحفظ المسودات وتتبع الأداء. لديك حساب؟ هذا الزر ينقلك مباشرة إلى لوحتك.",
  },
  {
    target: "nav-account",
    title: "Your Account",
    titleAr: "حسابك",
    description: "Open your profile, your dashboard, become a referral partner, or sign out — all from this avatar menu.",
    descriptionAr: "افتح ملفك الشخصي، لوحتك، انضم كشريك إحالة، أو سجّل الخروج — كل ذلك من قائمة الصورة الرمزية.",
  },
  {
    target: "home-hero",
    title: "Saudi Arabia, On-Screen",
    titleAr: "المملكة العربية السعودية، على الشاشة",
    description: "The largest curated DOOH and influencer network in the Kingdom — book screens, creators, and events from one platform.",
    descriptionAr: "أكبر شبكة منسّقة للإعلانات الرقمية الخارجية والمؤثرين في المملكة — احجز الشاشات والمبدعين والفعاليات من منصة واحدة.",
  },
  {
    target: "home-features",
    title: "What You Can Do",
    titleAr: "ما يمكنك فعله",
    description: "Strategic locations, smart targeting, programmatic delivery, and AI-assisted planning — explore the highlights below.",
    descriptionAr: "مواقع استراتيجية، استهداف ذكي، توصيل برمجي، وتخطيط بمساعدة الذكاء الاصطناعي — استكشف أبرز المزايا في الأسفل.",
  },
  {
    target: "home-cta",
    title: "Launch a Campaign",
    titleAr: "أطلق حملة",
    description: "When you're ready, this is where it begins. Pick locations, schedule dates, upload creatives, and go live.",
    descriptionAr: "عندما تكون جاهزاً، تبدأ من هنا. اختر المواقع، حدّد التواريخ، ارفع التصاميم، وانطلق.",
  },
  {
    target: "tour-help-button",
    title: "Replay Anytime",
    titleAr: "أعد التشغيل في أي وقت",
    description: "This button replays the tour on any page. Welcome aboard — let's build something brilliant.",
    descriptionAr: "هذا الزر يعيد تشغيل الجولة في أي صفحة. أهلاً بك — لنصنع شيئاً مميزاً.",
  },
];
